(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/controllers/big-stat-controller.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/controllers/big-stat-controller.js');

'use strict';

svs.maltipset.controllers.BigStatController = Marionette.MnObject.extend({
  initialize() {
    const self = this;
    self.maltipsetController = self.options.controller;
  },
  updateBigNavUrlParam(eventNr) {
    const url = new URL(window.location);
    const query = new URLSearchParams(url.search);
    if ((url.searchParams.has('event') || eventNr >= 0) && eventNr >= 0 && eventNr !== url.searchParams.get('event')) {
      query.set('event', eventNr);
      url.search = query;
      if (svs.core.detect.formfactor.mobile()) {
        window.history.pushState({}, '', url);
      } else {
        window.history.replaceState({}, '', url);
      }
    }
  },
  showBigNav(_ref) {
    let {
      match,
      drawNumber,
      productId,
      matchList
    } = _ref;
    const matchId = match === null || match === void 0 ? void 0 : match.matchId;
    let modulePath = window.location.pathname;
    if (window.location.pathname.split('/')[4]) {
      modulePath = modulePath.replace(window.location.pathname.split('/')[4], '');
    }
    const matchNum = parseInt(window.location.pathname.split('/')[3].split('-')[0], 10);
    for (let i = 0; i < matchList.length; i++) {
      matchList[i].set('isSelected', false);
    }
    const matchFromMatchList = matchList[matchNum - 1];
    if (svs.core.detect.formfactor.mobile()) {
      if (document.getElementById('maltipset-nav')) {
        svs.components.sportinfo.bigstat.unmountBigStatModal(document.getElementById('maltipset-nav'));
      }
      svs.components.sportinfo.bigstat.renderBigStatModal('#maltipset-nav', {
        closeNavigationCallback: () => {
          Backbone.history.navigate("".concat(drawNumber), {
            trigger: false,
            replace: false
          });
        },
        unmountBigStatCallback: () => {
          svs.components.sportinfo.bigstat.unmountBigStatModal(document.getElementById('maltipset-nav'));
        }
      }, {
        branding: 'maltipset-my-bets',
        betslip: true,
        classNameWrapper: 'big-stat',
        modulePath,
        matchId,
        productId,
        drawNumber,
        isWideDevice: svs.core.detect.formfactor.desktop(),
        theme: 'LIGHT',
        navigationCallback(dir) {
          const dirEventNumber = matchNum + dir;
          let targetUrl = "/".concat(drawNumber, "/").concat(dirEventNumber);
          if (dirEventNumber > 0 && dirEventNumber <= matchList.length) {
            const eventDescription = matchList[dirEventNumber - 1].get('eventDescription').replace(/ /g, '');
            targetUrl = "".concat(targetUrl, "-").concat(svs.utils.url.encode(eventDescription));
            targetUrl && Backbone.history.navigate(targetUrl, {
              replace: true,
              trigger: true
            });
          }
          svs.components.contextualMenu.toggleVisibility();
        }
      });
    } else {
      if (document.getElementById('content-column')) {
        svs.components.sportinfo.bigstat.unmountBigStat(document.getElementById('content-column'));
      }
      matchFromMatchList.set('isSelected', true);
      svs.components.sportinfo.bigstat.renderBigStat('#content-column', {
        branding: 'maltipset',
        classNameWrapper: 'big-stat',
        modulePath,
        matchId,
        productId,
        drawNumber,
        isWideDevice: svs.core.detect.formfactor.desktop(),
        theme: 'DARK',
        onBannerCloseClick() {
          for (let i = 0; i < matchList.length; i++) {
            matchList[i].set('isSelected', false);
          }
          const coupon = svs.maltipset.collections.coupons.getCurrentCoupon();
          coupon.set('selectedMatch', null, {
            silent: true
          });
          Backbone.history.navigate('', {
            trigger: true,
            replace: true
          });
          ReactDOM.unmountComponentAtNode(document.getElementById('content-column'));
        }
      });
    }
  }
});

 })(window);